<template>
    <div>
        <div>{{showStatus}}</div>
        <div class="about-to-start">
            <h1 class="status">{{ aboutToStart }}</h1>
            <div class="block" v-for="session in imminentSessions">
              <h2 style="color:#297ec0"><a :href="link(session.session_id)">{{ session.session.title }}</a>
                <small>#{{ session.session_id }}</small></h2>
              <p>{{ getTime(session.session.starts_at, session.session.ends_at) }}</p>
              <p>
                <span class="tag is-danger" v-show="session.session.is_cancelled">CANCELLED</span>
                <a v-show="!session.session.is_cancelled" :href="goToUrl(session)" class="tag" :style="sessionTagColor(session.session.urlType)" target="_blank">
                  Go to {{ session.session.locationName }}
                </a>
                <span v-show="session.session.formatName" class="tag">
                {{ session.session.formatName }}</span>
              </p>
              <p><span v-show="session.session.typeName" class="tag" :style="tagColor(session)">
                {{ session.session.typeName }}</span>
                <span v-show="session.session.subtypeName" class="tag is-default">
                {{ session.session.subtypeName }}</span></p>
              <p v-if="session.session.is_promotional">
                <span class="is-danger tag">Promotional</span>
                <span v-if="session.session.organization">
              Visit <a target="_blank" :href="organizationUrl(session.session)">
                {{ session.session.organization.name }}
              </a>
                </span>
              </p>
              <div class="presenters">
                    <span class="pr" v-for="p in session.session.participants">
                      <span>{{ showName(p) }}</span>
                      <span class="delimiter"> / </span>
                    </span>
              </div>
            </div>

        </div>
        <div class="in-progress">
          <h1 class="status">{{ inProgress }}</h1>
          <div class="block" v-for="session in progressSessions">
            <h2 style="color:#297ec0"><a :href="link(session.session_id)">{{ session.session.title }}</a>
              <small>#{{ session.session_id }}</small></h2>
            <p><small>{{ getTime(session.session.starts_at, session.session.ends_at) }}</small></p>
            <p>
              <span class="tag is-danger" v-show="session.session.is_cancelled">CANCELLED</span>
              <a v-show="!session.session.is_cancelled" :href="goToUrl(session)" class="tag" :style="sessionTagColor(session.session.urlType)" target="_blank">
                Go to {{ session.session.locationName }}
              </a>
              <span v-show="session.session.formatName" class="tag">
                {{ session.session.formatName }}</span>
            </p>
            <p><span v-show="session.session.typeName" class="tag" :style="tagColor(session)">
                {{ session.session.typeName }}</span>
              <span v-show="session.session.subtypeName" class="tag is-default">
                {{ session.session.subtypeName }}</span></p>
            <p v-if="session.session.is_promotional">
              <span class="is-danger tag">Promotional</span>
              <span v-if="session.session.organization">
              Visit <a target="_blank" :href="organizationUrl(session.session)">
                {{ session.session.organization.name }}
              </a>
                </span>
            </p>
            <div class="presenters">
                    <span class="pr" v-for="p in session.session.participants">
                      <span>{{ showName(p) }}</span>
                      <span class="delimiter"> / </span>
                    </span>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SessionLive",
        computed: {
            aboutToStart: function () {
                return this.imminentSessions.length ? 'About to Start' : '';
            },
            inProgress: function () {
                return this.progressSessions.length ? 'In Progress' : '';
            },
            showStatus: function () {
                return (this.progressSessions.length || this.imminentSessions.length) ? '' :
                    this.inStatus;
            },
            inStatus: function () {
                if (this.relativeTime === -1) {
                    return "Event hasn't started. Please come back later.";
                }
                if (this.relativeTime === 1) {
                    return "Event has finished.";
                }
                return "We may be on a break.";
            }
        },
        props:
            {
                event: {
                    type: Object,
                    required: true
                },
                relativeTime: {
                    type: Number,
                    required: true,
                }
            },
        data() {
            return {
                //sessions: [],
                imminentSessions: [],
                progressSessions: [],
                interval: null,
            }
        },

      created() {

        this.fetchItems();
        setInterval(function () {
          this.fetchItems();
        }.bind(this), 30000);


        /*
        window.Echo.channel('live-sessions')
            .listen('LiveSessionsUpdated', ({session}) => {

                //console.log(session.id);
                //console.log(action);

                if (session.event_id === this.event.id) {
                    if (session.session_progress === 15) {  // moved to about to start
                        //console.log(session.id);
                        //console.log('imminent');
                        this.imminentSessions.push(session);
                        this.progressSessions = this.removeFromArrayFilter(this.progressSessions, session.id);

                    } else if (session.session_progress === 20) {  // moved to in progress
                        //console.log(session.id);
                        //console.log('in progress');

                        // prevent duplication
                        if (this.progressSessions.includes(session) === false){
                            this.progressSessions.push(session);
                        }

                        this.imminentSessions = this.removeFromArrayFilter(this.imminentSessions, session.id);
                        //this.imminentSessions = this.removeIndex(this.imminentSessions, session.id);
                    } else {  // moved to anything else
                        this.progressSessions = this.removeFromArrayFilter(this.progressSessions, session.id);
                        this.imminentSessions = this.removeFromArrayFilter(this.imminentSessions, session.id);
                    }
                }
            });
         */
        },
        methods: {

          organizationUrl: function (session) {
            const organization = {};
            if (session.organization) {
              return '/organization/' + session.organization.id;
            }
            return '';
          },

          fetchItems: function () {
            //console.log("Fetch");
            axios.get('/api/event/' + this.event.id + '/schedule/live/imminent')
                .then(response => (this.imminentSessions = response.data));

            axios.get('/api/event/' + this.event.id + '/schedule/live/in-progress')
                .then(response => (this.progressSessions = response.data));
          },
          showName: function (p) {
            const name = p.member && p.member.name;
            if(name){
              return name;
            }
            return p && p.temp_name;
          },

          tagColor: function (session) {
            return 'color: white; background:' + session.session?.type?.color;
          },
          sessionTagColor: function (session) {
            if (session === 'youtube') {
              return 'color: #FFF; background: #F00';
            }
            return 'color: #FFF; background: #009';
          },
          link: function (id) {
            return '/session/' + id;
          },
          goToUrl: function (session) {
            return session.session.url;
          },
          avatar: function (link) {
            return '/' + link;
          },
          getStartTime: function (isoTime) {
            let jst = moment.tz(isoTime, "Asia/Tokyo");
            //let time = Date.parseLocale(isoTime);
            //console.log(jst);
            //return jst.format('H:mm');
            return jst.format('ddd, MMMM Do, H:mm');
          },
          getEndTime: function (isoTime) {
            let jst = moment.tz(isoTime, "Asia/Tokyo");
            //let time = Date.parseLocale(isoTime);
            //console.log(jst);
            return jst.format('H:mm [JST]');
          },

          getTime: function (isoTimeStart, isoTimeEnd) {
            let jstStart = moment.tz(isoTimeStart, "Asia/Tokyo");
            let dayStart = jstStart.format('MMMM Do');
            let jstEnd = moment.tz(isoTimeEnd, "Asia/Tokyo");
            let dayEnd = jstEnd.format('MMMM Do');
            if (dayStart === dayEnd) {
              return jstStart.format('ddd, MMM Do, HH:mm') + ' ~ ' + jstEnd.format('HH:mm [JST]');
            }
            return jstStart.format('ddd, MMM Do, HH:mm') + ' ~ ' + jstEnd.format('ddd, MMM Do, HH:mm [JST]');
          },

          removeFromArrayFilter: function (array, id) {

            let remove = id;

            let filtered = array.filter(function (value, index, fullArray) {
              //console.log(value.id !== remove);
              return value.id !== remove;
            });

            return filtered;
          },

          /*
          removeIndex: function (array, id) {
              let removeIndex = array.map(function (item) {
                  return item.id;
              }).indexOf(id);
              return array.slice(removeIndex, 1);
          }
          */
        }


    };
</script>

<style scoped>
.block {
  border-top: 1px solid #cccccc;
}

.delimiter {
  color: #ccc;
}

.pr:last-child .delimiter {
  display: none;
}

.about-to-start .status {
  margin-bottom: 5px;
  color: orange;
}

.in-progress .status {
  margin-bottom: 5px;
  color: green;
}

.in-progress {
  padding-top: 10px;
}
</style>